import { render, staticRenderFns } from "./PassengerTransportationPermissions.vue?vue&type=template&id=7d177072"
import script from "./PassengerTransportationPermissions.vue?vue&type=script&lang=ts"
export * from "./PassengerTransportationPermissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports